let _this;
import scheduleDetails from '../commonComponents/scheduleDetailsModal.vue'

export default {
  name: "access-code-detail",
  components: {scheduleDetails},
  props: {
    // 是否存在临时AC
    'exitTempAC':{
      type:Boolean,
      default:false
    },
    // 如果存在临时AC，则需要传区域和schedule
    'scheduleList':{
      type:Array,
      default(){
        return []
      }
    },
    'accessZoneList':{
      type:Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      acDetailModal: false,
      titleData: [],
      moreTableData: [],
      scheduleName: '',
      acDetailInfo:{},/*AC详情数据*/
    }
  },
  watch: {
    'acDetailModal': {
      handler(nv) {
        if (nv && _this.acDetailInfo.isTemp) {
          _this.titleData = [{
            title: 'Schedule',
            slot: 'scheduleName',
            minWidth: 180
          }, {
            title: 'Area',
            key: 'areaName',
            minWidth: 180
          }, {
            title: 'Access Zone',
            slot: 'accessZone',
            minWidth: 180
          }];
        } else if (nv && !_this.acDetailInfo.isTemp) {
          _this.titleData = [{
            title: 'Tag',
            slot: 'tag',
            minWidth: 180
          }, {
            title: 'Schedule',
            slot: 'scheduleName',
            minWidth: 180
          }, {
            title: 'Area',
            key: 'areaName',
            minWidth: 180
          }, {
            title: 'Access Zone',
            slot: 'accessZone',
            minWidth: 180
          }]
        }
      }
    }
  },
  mounted() {
    _this = this;
  },
  methods: {
    // 获取AC详情
    getACDetails:function (row) {
      _this.acDetailInfo = {name:row.accessCodeName,items:[]};
      // 临时AC
      if(!row.accessCodeId){
        _this.acDetailInfo.isTemp = true;
        row.schedules.forEach(schedule =>{
          let scheduleInfo = _this.scheduleList.find(item => schedule.scheduleId === item.id);
          _this.acDetailInfo.items.push({
            scheduleName: scheduleInfo ? scheduleInfo.name : '-',
            scheduleId:schedule.scheduleId,
            areaName: '',
            tags: [],
            accessZone:_this.accessZoneList.filter(item => schedule.accessZoneIds.indexOf(item.id) > -1)
          })
        });
        _this.acDetailModal = true;
      }else{
        this.$ajax.get('/AccessCode/QueryDetail?id=' + row.accessCodeId).then(function (res) {
          if (res.data.success) {
            let data = JSON.parse(JSON.stringify(res.data.data));
            _this.acDetailInfo.isTemp = data.isTemp;
            _this.acDetailInfo.uniqueId = data.uniqueId || data.serialNumber;
            if(data.schedules.length > 0){
              data.schedules.forEach(schedule => {
                if(schedule.areas.length > 0){
                  schedule.areas.forEach((area,index) => {
                    _this.acDetailInfo.items.push({
                      scheduleName: schedule.name,
                      scheduleId:schedule.id,
                      areaName: area.name,
                      tags: data.tags,
                      accessZone:area.zones,
                      isNeedMerge: true,
                      mergeCount: schedule.areas.length, //合并列数
                      mergeStart: index === 0 //合并列开始项
                    })
                  })
                }else{
                  _this.acDetailInfo.items.push({
                    scheduleName: schedule.name,
                    scheduleId:schedule.id,
                    areaName: '',
                    tags: [],
                    accessZone:[]
                  })
                }
              })
            }
            console.log(_this.acDetailInfo);
            _this.acDetailModal = true;
          } else {
            _this.messageNotice('error', res.data.message);
          }
        })
      }
    },
    //查看schedule
    viewSchedule: function (row) {
      this.$ajax.post('Schedule/PagingOption', {enabledPaging: false, ids: [row.scheduleId]}).then(function (res) {
        if (res.data.success) {
          _this.moreTableData = [];
          let scheduleInfo = res.data.data.items[0];
          // 获取schedule组合
          scheduleInfo.showTimeArray = [];
          scheduleInfo.showTimeArray = _this.shareApi.makeScheduleDetail(scheduleInfo.schedules);
          _this.scheduleName = row.scheduleName;
          scheduleInfo.showTimeArray.forEach(item => {
            if (item !== undefined) {
              _this.moreTableData.push({
                'week': item.substring(0, item.indexOf(":")),
                'time': (item.substring(item.indexOf(":") + 2)).split(',')
              });
            }
          });
          _this.$refs.scheduleDetail.moreScheduleModal = true
        } else {
          _this.messageNotice('error', res.data.success);
        }
      });
    },
    // 合并列
    handleSpan({row, column, rowIndex, columnIndex}) {
      if(_this.acDetailInfo.isTemp && row.mergeStart && columnIndex === 0){
        console.log(rowIndex);
        return {
          rowspan: row.mergeCount,
          colspan: 1
        };
      }else if(_this.acDetailInfo.isTemp && !row.mergeStart && columnIndex === 0){
        return {
          rowspan: 0,
          colspan: 1
        };
      }
      else if (!_this.acDetailInfo.isTemp && rowIndex === 0 && columnIndex === 0) {
        return {
          rowspan: _this.acDetailInfo.items.length,
          colspan: 1
        };
      } 
      else if (!_this.acDetailInfo.isTemp && rowIndex > 0 && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 1
        };
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/staffManagement/accessCodeDetail.js